import React, { useState } from "react";
import { motion } from "framer-motion";

const steps = [
  { title: "Personal & Background", fields: ["ageGroup", "gender", "city"] },
  { title: "Education & Skills", fields: ["qualification", "skills", "tools"] },
  { title: "Career Goals", fields: ["industry", "jobRole", "workPreference"] },
  { title: "Experience", fields: ["yearsExperience", "keyProjects"] },
  { title: "Strengths & Values", fields: ["strengths", "values", "motivation"] },
];

export default function QuestionnaireWizard() {
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});
  const totalSteps = steps.length;
  const progress = Math.round(((step + 1) / totalSteps) * 100);

  const handleNext = () => {
    if (step < totalSteps - 1) setStep(step + 1);
  };
  const handlePrev = () => {
    if (step > 0) setStep(step - 1);
  };

  const handleChange = (field, value) => {
    setAnswers({ ...answers, [field]: value });
  };

  const current = steps[step];

  return (
    <div className="min-h-screen bg-[#0d0d1a] flex flex-col items-center justify-center text-white px-6 py-12 font-sans relative overflow-hidden">
      {/* Gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#1a1a2e] to-[#0d0d1a] opacity-90"></div>

      <div className="max-w-2xl w-full bg-[#141428]/90 border border-[#EB6AB5]/20 rounded-2xl p-8 shadow-2xl backdrop-blur-md relative z-10">
        {/* Progress Bar */}
        <div className="flex justify-between items-center mb-4 text-sm text-[#EB6AB5]/80">
          <span>Step {step + 1} of {totalSteps}</span>
          <span>{progress}% Complete</span>
        </div>
        <div className="w-full h-2 bg-[#1e1e30] rounded-full mb-6">
          <motion.div
            className="h-2 rounded-full bg-gradient-to-r from-[#EB6AB5] to-[#ff83d1]"
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ duration: 0.4 }}
          />
        </div>

        {/* Step Title */}
        <h2 className="text-2xl font-bold text-[#EB6AB5] mb-6">
          {current.title}
        </h2>

        {/* Step Fields */}
        <motion.div
          key={step}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="space-y-4"
        >
          {current.fields.map((field) => (
            <div key={field}>
              <label className="block text-sm text-[#EB6AB5]/80 mb-1 capitalize">
                {field.replace(/([A-Z])/g, " $1")}
              </label>
              <input
                type="text"
                value={answers[field] || ""}
                onChange={(e) => handleChange(field, e.target.value)}
                placeholder={`Enter ${field.toLowerCase()}`}
                className="w-full p-3 bg-[#1c1c2e] rounded-lg border border-[#EB6AB5]/30 focus:border-[#EB6AB5] outline-none text-white placeholder-gray-400"
              />
            </div>
          ))}
        </motion.div>

        {/* Buttons */}
        <div className="flex justify-between items-center mt-8">
          <button
            disabled={step === 0}
            onClick={handlePrev}
            className="text-gray-400 hover:text-white transition disabled:opacity-30"
          >
            ← Back
          </button>

          {step === totalSteps - 1 ? (
            <button
              onClick={() => alert("✅ Submitted Successfully!")}
              className="bg-[#EB6AB5] px-6 py-3 rounded-full font-semibold hover:bg-[#ff83d1] transition"
            >
              Submit
            </button>
          ) : (
            <button
              onClick={handleNext}
              className="bg-[#EB6AB5] px-6 py-3 rounded-full font-semibold hover:bg-[#ff83d1] transition"
            >
              Next →
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
